import debug from 'debug';

import { BaseActions } from '../Common/Actions/BaseActions';
import { execAction } from '../Common/Actions/handler';
import { ResponseEither } from '../Common/ResponseEither';
import CartRequestBuilder from './CartRequestBuilder';
import { ICartCountPayload } from './interfaces/ICartCountPayload';
import { ICartCountRequestParams } from './interfaces/ICartCountRequestParams';

const log = debug('sunny:CartActions');

export default class CartActions extends BaseActions<CartRequestBuilder> {
  cartCount(params: ICartCountRequestParams): Promise<ResponseEither<ICartCountPayload>> {
    log('Get cart count');
    return execAction('Get cart count', this.requestBuilder.createGetCartCountQuery(params));
  }
}
